<template>
    <div class=" bg-a-egg-f5ebdc min-h-screen">
        <div class=" content-page p-4">
            <Content
                class=" text-a-brown-502314"
            ></Content>
        </div>
    </div>
</template>

<script>
import Content from '@/module/CrownPoint/component/content.vue';
import LocaleMixin from '@/mixin/LocaleMixin.js'
export default {
    name: 'crownpoint',
    mixins: [LocaleMixin],
    components: {
        Content
    },
    created: function() {
        var localeCode = this.$route.query.locale
        this.switchLang(localeCode)
    }
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .content-page {
        min-height: 100vh;
    }
</style>
